import { Link } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import { useSeo } from "@/hooks/useSeo";
import { media } from "@/lib/api";

export default function Collections() {
  const { data, loading } = useFetch("/store/collections");
  useSeo("Collections", "Curated edits across womenswear and menswear.");
  const items = data?.items || [];
  return (
    <div className="container-lux pt-8 pb-20" data-testid="collections-page">
      <nav className="text-xs text-muted-foreground mb-6" data-testid="breadcrumbs"><Link to="/" className="hover:text-foreground">Home</Link><span className="mx-1.5">/</span><span className="text-foreground">Collections</span></nav>
      <header className="max-w-2xl mb-10"><h1 className="text-5xl sm:text-6xl font-medium">Collections</h1><p className="text-foreground/70 mt-4 leading-relaxed">Edits built around a mood, a season, or a technique — refreshed throughout the year.</p></header>
      {loading && <p className="text-sm text-muted-foreground">Loading…</p>}
      {!loading && items.length === 0 && <p className="text-sm text-muted-foreground" data-testid="collections-empty">No collections live right now. Please check back soon.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-testid="collections-grid">
        {items.map((c) => (
          <Link key={c.slug} to={`/collections/${c.slug}`} className="group block" data-testid={`collections-card-${c.slug}`}>
            <div className="aspect-[4/5] bg-white rounded-md overflow-hidden">{c.hero_image_url && <img src={media(c.hero_image_url, 900)} alt="" className="w-full h-full object-cover img-zoom" loading="lazy" />}</div>
            <p className="eyebrow mt-4">{c.gender === "all" ? "All" : c.gender === "women" ? "Women" : "Men"} · {c.product_count} pieces</p>
            <p className="font-display text-2xl mt-1 leading-tight">{c.name}</p>
            <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{c.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
